import { useTranslate } from '@tolgee/react'
import { ButtonOption, OptionsButton } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

interface Props {
  id: number
}

export const OperationalEquipmentMenuOptions = observer(({ id }: Props) => {
  const { t } = useTranslate()
  const navigate = useNavigate()

  const options: ButtonOption[] = [
    {
      label: t('viewDetails', 'View details'),
      onClick: () => navigate(`${id}`),
      testId: 'operational-equipment-options-edit',
    },
  ]

  return (
    <OptionsButton options={options} position='right' testId='operational-equipment-options-btn' />
  )
})
